<div class="modal-header">
    <h4 class="modal-title">Detalles de Proveedor</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row d-flex align-items-center">

            <div class="mb-3 col-12 col-sm">
                <label for="nombre">Nombre</label>
                <input type="text" class="form-control" id="nombre" formControlName="nombre">
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="apellido">Apellido</label>
                <input type="text" class="form-control" id="apellido" formControlName="apellido">
            </div>
        </div>
      
       
        <div class="row">
            <div class="mb-3 col-12 col-sm">
                <label for="razon_social">Razón Social</label>
                <input type="text" class="form-control" id="razon_social" formControlName="razon_social">
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="email">Email</label>
                <input type="text" class="form-control" id="email" formControlName="email">
            </div>
        </div>
        <div class="row">
            <div class="mb-3 col-12 col-sm">
                <label for="fono">Fono</label>
                <input type="text" class="form-control" id="fono" formControlName="fono">
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="precio_compra">Fono 2</label>
                <input type="text" class="form-control" id="fono2" formControlName="fono2">
            </div>
        </div>
        <div class="row">
            <div class="mb-3 col-12 col-sm">
                <label for="direccion">Dirección</label>
                <input type="text" class="form-control" id="direccion" formControlName="direccion">
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="estado">Estado</label>
                <ng-select  [items]="estado" bindLabel="name" bindValue="id" formControlName="estado">
                </ng-select>
            </div>
            
        </div>

    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cerrar</button>
</div>